import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { Rodeo } from '../../../../model/rodeo';

@Component({
    selector: 'timer-prompt',
    templateUrl: 'timer-prompt.html'
})
export class TimerPromptPage {
    rodeo: Rodeo;

    usingRodeoLive: boolean = false;
    baudRate: string = "9600";

    constructor(navParams: NavParams, private viewController: ViewController) {
        this.rodeo = navParams.get('rodeo');
    }

    cancel() {
        this.viewController.dismiss();
    }

    connect() {
        this.viewController.dismiss({ rodeoLive: this.usingRodeoLive, baudRate: this.baudRate });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/scoring/timer-prompt.ts